import { Component, OnInit, OnDestroy} from '@angular/core';
// services
import { CopyService } from '../../../shared/services/app-copy.service';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// models
import { AppState } from '../../../booking/models/app-state.interface';

@Component({
  selector: 'app-error-404',
  templateUrl: './error-404.component.html',
  styleUrls: ['./error-404.component.scss']
})
export class Error404Component implements OnInit, OnDestroy {

  private _bookingInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;

  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _copyService: CopyService
  ) {}

  ngOnInit() {

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
            this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {

              this.getCopy();
            }

            this._userLanguageSubscription = this._appStore.select('copyReducer')
              .subscribe((res: any) => {
                this.selectedLanguage = res.language
              })

        });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'error-404',
      ['panelHeader']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  ngOnDestroy() {
    if (this._bookingInitSubscription) {this._bookingInitSubscription.unsubscribe();}
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
  }
}
